define(
    'modals/secured/subscription/select',[
        "providers/dataprovider",
        "plugins/dialog",
        "i19n!i19n/strings",
        "plugins/router",
        "viewmodels/message"
    ],
    function (dataProvider, dialog, i19n, router, message) {
        var _spin = 0;

        var modal = function Modal() {
            var self = this;

            self.i19n = i19n;
            self.isShowPlan = ko.observable(true);
            self.isShowLocalConfirm = ko.observable(false);
            self.isConfirmPaymentEnabled = ko.observable(false);
            self.isReviewAndConfirmEnabled = ko.observable(false);
            self.confirmPaymentText = ko.observable(i19n.to.confirm);
            self.header = ko.observable('');
            self.paymentUrl= ko.observable('');

            self.plan = {};

            self.additionalUsers = 0;
            
            self.totalUsers = ko.observable(0);            

            self.summaryAdditionalUsers = ko.observable(0);
            self.summaryAdditionalUsersPrice = ko.observable(0);
            self.summaryTotalUsers = ko.observable(0);
            self.summaryTotalUsersPrice = ko.observable(0);

            self.nonUsers = 0;
            self.minUsers = 0;
            
            self.isShowWarningUsers = ko.observable(false);
            self.closeNotification = function () {
                self.isShowWarningUsers(false);
            };

            self.toreducethetotalnumberofuserssetsomeusersto = ko.observable('');
        }
   
        modal.prototype.activate = function (plan) {
            var self = this;            

            self.mode = plan._modal;

            self.toreducethetotalnumberofuserssetsomeusersto(i19n.to.toreducethetotalnumberofuserssetsomeusersto);
            self.header(i19n.to.howmanyusersdoyouneed);

            self.plan = plan;

            self.minUsers = self.mode == "adduser" ? (self.plan.activeUsers > self.plan.includedUsers ? self.plan.activeUsers : self.plan.includedUsers) - self.plan.subsUsers : 0;
            
            _spin = 1 + self.minUsers;
            
            if(self.mode == "trial")
                updateView(self, 0);
            if(self.mode == "adduser")
                updateView(self, self.minUsers > 0 ? self.minUsers : 0);
        };
        modal.prototype.attached = function () {
            var self = this;

            $("#additionalUsers-textbox")
            .kendoNumericTextBox({
                min: self.minUsers,
                max: 999,
                value: self.minUsers < 0 ? 0 : self.minUsers,
                format: "#",
                spin: function () {

                    if (self.plan.activeUsers > self.plan.includedUsers) {
                        if (this.min() == this.value()) {

                            if ((this.value() - _spin) < this.min()) {
                                self.isShowWarningUsers(true);
                                _spin = 0;
                            }

                            _spin++;
                        }

                        if (this.value() > this.min()) {
                            self.isShowWarningUsers(false);
                            _spin = 0;
                        }
                    }

                    updateView(self, this.value());
                },
                change: function () {
                    updateView(self, this.value());
                }
            });            
        };

        function updateView(self, value) {
            if (self.mode == "trial") {
                var additionalUsers = (self.plan.activeUsers + value) - self.plan.includedUsers;

                additionalUsers = additionalUsers < 0 ? 0 : additionalUsers;

                self.totalUsers(self.plan.activeUsers + value);

                self.summaryAdditionalUsers(additionalUsers);
                self.summaryAdditionalUsersPrice(self.summaryAdditionalUsers() * self.plan.pricePerUser);

                self.summaryTotalUsers(additionalUsers + self.plan.includedUsers);
                self.summaryTotalUsersPrice(self.plan.price + self.summaryAdditionalUsersPrice());
            }

            if (self.mode == "adduser") {
                self.totalUsers(self.plan.subsUsers + value);

                self.summaryAdditionalUsers(self.plan.subsUsers + value - self.plan.includedUsers);
                self.summaryAdditionalUsersPrice(self.summaryAdditionalUsers() * self.plan.pricePerUser);

                self.summaryTotalUsers(self.plan.subsUsers + value);
                self.summaryTotalUsersPrice(self.plan.price + self.summaryAdditionalUsersPrice());
            }

            self.additionalUsers = self.summaryAdditionalUsers();

            self.isReviewAndConfirmEnabled(value != 0 || !self.plan.isCurrent);
        }

        modal.prototype.ok = function () {
            var self = this;

            if (self.confirmPaymentText() == "Processing...")
                return;

            if (self.isShowPlan()) {
                dialog.close(self, { ok: true });
            } else {
                self.header(i19n.to.howmanyusersdoyouneed);
                self.isShowPlan(true);
            }
        };
        modal.prototype.clickEnterPaymentDetails = function () {
            var self = this;              

            self.isShowLocalConfirm(false);

            var data = {
                instanceId: window.fileplan.instanceCode,
                planCode: self.plan.code,
                additionalUsers: self.additionalUsers
            };

            dataProvider.subscription
            .checkoutSubscription(data)
            .done(function (data) {
                self.paymentUrl(data.accessUrl);
                self.header(i19n.to.enterpaymentdetails);
                self.isShowPlan(false);
            })
            .fail(function (e) {
                console.error(e);
            });
        };
   
        modal.prototype.reviewAndConfirm = ko.asyncCommand({
            canExecute: function (isExecuting) {
                return !isExecuting;
            },
            execute: function (complete) {
                var self = this;

                self.isShowLocalConfirm(true);
                self.header("Review and Confirm");
                self.isShowPlan(false);
                self.isConfirmPaymentEnabled(false);

                setTimeout(function () {
                    self.confirmPaymentText(i19n.to.confirm);
                    self.isConfirmPaymentEnabled(true);
                    complete();
                }, 3000);
            }
        });
        modal.prototype.confirmPayment = ko.asyncCommand({
            canExecute: function (isExecuting) {
                return !isExecuting;
            },
            execute: function (complete) {
                var self = this;

                var data = {
                    instanceId: window.fileplan.instanceCode,
                    planCode: self.plan.code,
                    additionalUsers: self.additionalUsers
                };

                self.confirmPaymentText("Processing...");
                self.isConfirmPaymentEnabled(false);
                self.header("Processing");

                dataProvider.subscription
                .updateSubscription(data)
                .done(function (data) {
                    message.title("Payment Confirmation");
                    message.message("Your subscription is now being updated. Once completed, an invoice will be sent to your email.");
                    message.message2("Thank you.");

                    self.header("Done. Thank You");

                    setTimeout(function () {
                        //try {
                        //    window.close();
                        //} catch (ex) { }

                        //dialog.close(self, { ok: true });

                        //router.navigate("#message");

                        dialog.close(self, { ok: true });

                        if (sessionStorage.navto) {
                            //router.navigate("#" + sessionStorage.navto);

                            // must reload
                            window.location.hash = "#" + sessionStorage.navto;
                            window.location.reload();
                        }

                        sessionStorage.removeItem("navto");
                    }, 2000);
                })
                .fail(function (e) {
                    self.header("Review and Confirm");

                    self.isConfirmPaymentEnabled(true);

                    console.error(e);
                })
                .always(function () {
                    self.confirmPaymentText(i19n.to.confirm);                    

                    complete();
                });
            }
        });

        return modal;
    }
);
